import { connect } from 'react-redux'
import * as redux from "redux";
import { FacetsAction } from 'dw_azsearchstore/dist/actions/facetsActions';
import { facetsActions, searchParameterActions, inputActions, asyncActions, Store } from 'dw_azsearchstore';
import TopMenu from '../components/top-menu/TopMenu';
import { SearchParametersAction } from 'dw_azsearchstore/dist/actions/searchParametersActions';

interface TopMenuContainerProps{
    languageFacet: Store.Facet;
}

function getReturnType<RT>(expression: (...params: any[]) => RT): RT {
    return {} as RT;
}

type TopMenuActions = FacetsAction | SearchParametersAction

const getLanguageFullName = (language: string) => {
    let lang: React.ReactText = "English";
    switch (language){
        case "es": lang = "Spanish"; break;
        case "fr": lang = "French"; break;
        case "de": lang = "German"; break;
        case "ja": lang = "Japanese"; break;
    }
    return lang; 
}

const mapDispatchToProps = (dispatch: redux.Dispatch<TopMenuActions>, ownProps: TopMenuContainerProps) => {
    return {
        onLanguageChange: (language: string) => {
            dispatch(facetsActions.clearFacetsSelections());
            dispatch(searchParameterActions.updateSearchParameters({skip: 0}));
            dispatch(facetsActions.toggleCheckboxFacetSelection("Language", getLanguageFullName(language)));
            dispatch(asyncActions.fetchSearchResultsFromFacet);
            window.scrollTo({top: 0, behavior: "smooth"});
        }
    }
}

const dispatchProps = getReturnType(mapDispatchToProps);

export const TopMenuContainer = connect(null, mapDispatchToProps)(TopMenu);
